function selectAmount(btn) {
  document.querySelectorAll('.amount-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelector('.custom-input-wrap input').value = '';
}
function clearAmountBtns() {
  document.querySelectorAll('.amount-btn').forEach(b => b.classList.remove('active'));
}


function giveNow() {
  var active = document.querySelector('.amount-btn.active');
  var custom = document.querySelector('.custom-input-wrap input');
  var amount = 0;
  if (custom && custom.value && parseFloat(custom.value) > 0) {
  amount = parseFloat(custom.value);
  } else if (active) {
  amount = parseFloat(active.textContent.replace(/[^0-9.]/g, ''));
  }
  var url = 'https://www.paypal.com/donate/?hosted_button_id=HYGKQJPZNUBDY';
  if (amount && amount > 0) {
  url += '&amount=' + amount.toFixed(2);
  }
  window.open(url, '_blank', 'noopener');
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cta = document.querySelector('.widget-cta');
    if (cta) {
    cta.addEventListener('click', giveNow);
    }
    var subtext = document.querySelector('.widget-subtext');
    if (subtext) {
    subtext.textContent = 'Every contribution supports vetted charities helping Israeli civilians';
    }
    });

    function sarSaveAmount() {
      var active = document.querySelector('.amount-btn.active');
      var custom = document.querySelector('.custom-input-wrap input');
      var amt = 0;
      if (custom && custom.value && parseFloat(custom.value) > 0) { amt = parseFloat(custom.value); }
      else if (active) { amt = parseFloat(active.textContent.replace(/[^0-9.]/g, '')); }
      try { if (amt > 0) { sessionStorage.setItem('sarAmount', String(amt)); } } catch (e) {}
      }
  
      function sarRestoreAmount() {
      var saved = 0;
      try { saved = parseFloat(sessionStorage.getItem('sarAmount')); } catch (e) { saved = 0; }
      if (!saved || saved <= 0) { return; }
      var buttons = document.querySelectorAll('.amount-btn');
      var custom = document.querySelector('.custom-input-wrap input');
      var matched = null;
      buttons.forEach(function (b) { if (parseFloat(b.textContent.replace(/[^0-9.]/g, '')) === saved) { matched = b; } });
      buttons.forEach(function (b) { b.classList.remove('active'); });
      if (matched) { matched.classList.add('active'); if (custom) { custom.value = ''; } }
      else if (custom) { custom.value = saved; }
      }

      document.addEventListener('DOMContentLoaded', function () {
      sarRestoreAmount();
      document.querySelectorAll('.amount-btn').forEach(function (b) { b.addEventListener('click', sarSaveAmount); });
      var ci = document.querySelector('.custom-input-wrap input');
      if (ci) { ci.addEventListener('input', sarSaveAmount); }
      var c2 = document.querySelector('.widget-cta');
      if (c2) { c2.addEventListener('click', sarSaveAmount); }
      });

function sarLoadPayPalButton(){var holder=document.getElementById('paypal-container-9WUQL56KMFQ92');if(!holder){return;}function r(){try{paypal.HostedButtons({hostedButtonId:'9WUQL56KMFQ92'}).render('#paypal-container-9WUQL56KMFQ92');}catch(e){}}if(window.paypal&&window.paypal.HostedButtons){r();return;}if(document.getElementById('sar-pp-sdk')){return;}var s=document.createElement('script');s.id='sar-pp-sdk';s.src='https://www.paypal.com/sdk/js?client-id=BAAZm4SeCnvyXbc7F-8UP1ZHF75Zl7dwYvK7vtzOYutLB9YD8VOjxL_JijnuPDJSNkSfCdzs6RA2kPblyc&components=hosted-buttons&enable-funding=venmo&currency=USD';s.crossOrigin='anonymous';s.onload=r;document.head.appendChild(s);}
document.addEventListener('DOMContentLoaded',function(){sarLoadPayPalButton();});